"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgSmile = function SvgSmile(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 13c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm0 2a9 9 0 100 18 9 9 0 000-18zm3.2 10.4a1 1 0 011.6 1.2c-.243.324-.669.769-1.274 1.209C26.506 28.549 25.325 29 24 29c-1.325 0-2.507-.45-3.526-1.191-.605-.44-1.031-.885-1.274-1.209a1 1 0 011.6-1.2c.132.176.425.481.85.791.7.51 1.487.809 2.35.809s1.65-.3 2.35-.809c.425-.31.718-.615.85-.791zM21.01 20a1 1 0 010 2H21a1 1 0 010-2zm6 0a1 1 0 010 2H27a1 1 0 010-2z",
    id: "smile_svg__a"
  }));
};

var _default = SvgSmile;
exports["default"] = _default;